<template>
  <div class="jumbotron"
    :class="{'jumbotron--image': bgImg}"
    :style="styles">
    <div class="container text-center">
      <div class="display--table h--third">
        <div class="display--cell middle">
          <div class="jumbotron__content">
            <slot />
          </div>
        </div>
      </div>
    </div>

    <bg-filter
      v-if="bgImg"
      rgba-color="rgba(0, 0, 0, .4)"
      class="jumbotron__filter" />
  </div>
</template>

<script>
import BgFilter from './BgFilter'

export default {
  components: {
    BgFilter
  },
  props: {
    bgImg: String,
    bgColor: String,
    bgPosition: String,
    useFilter: Boolean
  },
  data () {
    return {}
  },
  computed: {
    hasBgColor: function () {
      return typeof this.bgColor !== 'undefined'
    },
    styles: function () {
      let css = {}

      if (this.hasBgColor) css['background-color'] = `${this.bgColor}`

      if (this.bgImg) {
        css['background-image'] = `url(${this.bgImg})`
        css['background-position'] = this.bgPosition
      }

      return css
    }
  }
}
</script>

<style scoped lang="scss"></style>
